<template>
  <div
    data-testid="bulk-edit-options"
    class="flex min-h-16 items-center gap-2 overflow-hidden rounded-md py-3 transition-all"
    :class="{
      'bg-white px-2 shadow': isAnythingSelected,
    }"
  >
    <div v-if="isAnythingSelected">
      <BulkEditSelectionState />
    </div>
    <div class="overflow-hidden overflow-x-auto">
      <div class="stack">
        <div
          class="transition-all duration-300 ease-in-out"
          :class="{
            '-translate-x-full': !isAnythingSelected,
            'translate-x-0': isAnythingSelected,
          }"
        >
          <slot name="options" />
        </div>
        <div
          class="transition-all duration-300 ease-in-out"
          :class="{
            '-translate-x-full': isAnythingSelected,
            'translate-x-0': !isAnythingSelected,
          }"
        >
          <div class="flex h-full items-center">
            <slot name="noSelection" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, inject } from 'vue';
import { bulkEditInjectionKey } from './bulk-edit';
import BulkEditSelectionState from './BulkEditSelectionState.vue';

const bulkEdit = inject(bulkEditInjectionKey);
if (!bulkEdit) {
  throw new Error('This component can only be used inside a BulkEditGroup');
}
const isAnythingSelected = computed(() => bulkEdit.selection.value.length > 0);
</script>
<style scoped>
/* https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/ */
/* easy way to plop the elements on top of each other and have them both sized based on the tallest one's height */
.stack {
  display: grid;
}
.stack > *,
.stack::after {
  grid-area: 1 /1 /2 /2;
}
</style>
